import React, { Component } from "react";
import Predefine_Colar_Goalkeeper from "../components/Predefine_Colar_Goalkeeper/Predefine_Colar_Goalkeeper";

export class Predefine_Colar_GoalkeeperPage extends Component {
  render() {
    return <Predefine_Colar_Goalkeeper />;
  }
}

export default Predefine_Colar_GoalkeeperPage;
